import React, { useEffect, useState } from 'react';
import HeaderSCI from './HeaderSCI';
import './controlinterno.css';

const principios = [
  {
    id: 1,
    color: '#621132',
    title: "Principio 1. - Mostrar actitud de respaldo y compromiso.",
    items: [
        
      "Código de Ética",
      "Código de Conducta",
      "Carta de conocimiento del Código de Ética y Código de Conducta",
      "Lineamientos Generales que Establecen las Bases para la Integración, Organización y Funcionamiento del Comité de Ética y Prevención de Conflictos de interés",
      "Medios de difusión para dar a conocer el Código de Ética y Código de Conducta",
      "Integración del Comité de Ética y Prevención de Conflictos de interés.",
      "Programa de Promoción de la Integridad y Prevención de la Corrupción",
      "Programa de Trabajo Anual del Comité de Ética y Prevención de Conflictos de Interés"
    ]
  },
  {
    id: 2,
    color: '#9e2348',
    title: "Principio 2. - Ejercer la responsabilidad de Vigilancia.",
    items: [
      "Órgano Interno de Control",
      "Procedimiento para vigilar, detectar, investigar y documentar las posibles violaciones a los principios éticos y a las normas de conducta",
      "Medios de denuncia",
      "Comités Internos de Funciones Operativas de la Secretaría"
    ]
  },
  {
    id: 3,
    color: '#a98188',
    title: "Principio 3. - Establecer la estructura, responsabilidad y autoridad.",
    items: [
      "Reglamento Interior de la Secretaría de Contraloría del Poder Ejecutivo del Estado de Hidalgo",
      "Organigrama",
      "Manual de Organización",
      "Manual de Procedimientos Administrativos"
    ]
  },
  {
    id: 4,
    color: '#94824d',
    title: "Principio 4. - Demostrar compromiso con la competencia profesional.",
    items: [
      "Catálogo de Perfiles y Cargos de la Secretaría de Contraloría del Poder Ejecutivo del Estado de Hidalgo",
      "Lineamientos Administrativos",
      "Plan Anual de Capacitación y Desarrollo",
      "Procedimiento o mecanismo formalizado para evaluar el desempeño del personal",
      "Lineamientos del Proceso de Inducción Institucional e Inducción al Cargo",
      "Cuestionario de Clima Organizacional y No Discriminación"
    ]
  },
  {
    id: 5,
    color: '#645a5c',
    title: "Principio 5. - Establecer la Estructura para el Reforzamiento de la Rendición de Cuentas.",
    items: [
      "Coordinación de actividades referentes a control interno",
      "Mecanismo para Responsabilizar al Personal por sus Obligaciones Especificas en materia de Control Interno"
    ]
  }
];

const AmbienteControl = () => {
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const toggleAccordion = (id) => {
    setExpandedId(prev => (prev === id ? null : id));
  };

  return (
    <>
      <HeaderSCI title="COMPONENTES DEL CONTROL INTERNO" />

      <div className="container ci-nav pt-4">
        {/* Title pill */}
        <div className="row justify-content-center mb-4">
          <div className="col-12 col-md-5 d-flex justify-content-center">
            <div className="ci-nav__btn--pill" style={{ cursor: 'default', margin: 0 }}>
              Ambiente de Control
            </div>
          </div>
        </div>

        {/* Text Description */}
        <div className="row justify-content-center mb-5">
          <div className="col-12 col-md-10">
            <p className="ci-desc-text">
              Es la base del control interno, la cual proporciona disciplina y estructura para apoyar al personal en la consecución de los objetivos institucionales.
            </p>
          </div>
        </div>

        {/* Accordion / Toggle List */}
        <div className="row justify-content-center">
          <div className="col-12 col-md-10">
            {principios.map((prin) => {


              const isExpanded = expandedId === prin.id;

              return (
                <div key={prin.id} className="mb-2">
                  {/* Header Button */}
                  <div 
                    className="ci-nav__btn ci-nav__btn--doc" 
                    onClick={() => toggleAccordion(prin.id)}
                    style={{ cursor: 'pointer', padding: '8px 12px' }}
                  >
                    <div className="ci-nav__icon" style={{ backgroundColor: prin.color }}>
                      <i className="fa-solid fa-id-card"></i>
                    </div>
                    <span className="ci-nav__label ci-nav__label--doc" style={{ fontSize: '1rem', color: '#621132' }}>
                      {prin.title}
                    </span>
                  </div>

                  {/* Expanded Content */}
                  <div className={`ci-accordion-wrapper ${isExpanded ? 'is-open' : ''}`}>
                    <div className="ci-accordion-inner">
                      {prin.items.length > 0 ? (
                        <div className="ci-accordion-content ps-5 mt-1 mb-2">
                          <ul style={{ color: prin.color, fontSize: '0.95rem', fontStyle: 'italic', lineHeight: '1.6' }}>
                            {prin.items.map((item, idx) => (
                              <li key={idx} className="mb-2">
                                <a href="#" style={{ color: '#621132' }}>{item}</a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ) : (
                        <div className="ci-accordion-content ps-5 mt-1 mb-2">
                          <p style={{ color: '#621132', fontSize: '0.95rem', fontStyle: 'italic' }}>
                            No hay documentos disponibles.
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default AmbienteControl;
